import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { Heading } from '../../ComplianceContent';
import { SectionConfigurationContext } from '../SectionConfigurationContext';
import Stepper, { Status } from '../Stepper';
import { Section } from '../types';

type Props = {
  children: React.ReactNode;
  onStepChange: (section: Section) => void;
};

export const Root = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-flow: column nowrap;
  align-items: center;
  width: 100%;
  padding: 16px 0;
  gap: 32px;
`;

export const getSectionTitleTranslation = (section: Section) => {
  switch (section) {
    case 'basic-info':
      return <FormattedMessage id="compliance.kyb.sections.basic-info.title" />;
    case 'documents':
      return <FormattedMessage id="compliance.kyb.sections.documents.title" />;
    case 'beneficiaries':
      return <FormattedMessage id="compliance.kyb.sections.beneficiaries.title" />;
    case 'bank-details':
      return <FormattedMessage id="compliance.kyb.sections.bank-details.title" />;
    case 'review':
      return <FormattedMessage id="compliance.kyb.sections.review.title" />;
  }
};

const SectionsLayout = ({ children, onStepChange }: Props) => {
  const {
    params: { section },
  } = useRouteMatch<{ section: Section }>();
  const sections = useContext(SectionConfigurationContext);
  const sectionWithReview = sections.enabledSections.concat('review');

  const stepStatus = (selectedSection: Section): Status => (selectedSection === section ? 'active' : 'default');

  return (
    <Root>
      <Heading>{getSectionTitleTranslation(section)}</Heading>
      <Stepper
        onStepChange={onStepChange}
        getSectionTitleTranslation={getSectionTitleTranslation}
        items={sectionWithReview.map(selectedSection => ({
          status: stepStatus(selectedSection),
          section: selectedSection,
        }))}
      />
      {children}
    </Root>
  );
};

export default SectionsLayout;
